import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import * as AuthProxy from "./security/AuthProxy";
import { ConfigMap, configMap, setConfigMap } from "./utils/ConfigMap";
import Login from "./Login";

const fileConfig = "./assets/config.json";

fetch(fileConfig)
.then((res: any): any => {
  return res.json();
}).then((configJson): any => {
  setConfigMap(configJson[process.env.REACT_APP_API_ENV as string] as ConfigMap);
  (window as any).configMap = configMap;

  const query = new URLSearchParams(window.location.search);
  const code = query.get("code");
  var authType = sessionStorage.getItem("authType");
  const logout = query.get("logoff");
  // look for resume in URL for SSO 
  const query2=new URLSearchParams(window.location.search);
  const resume=query2.get("resume");

  // logout take priority, clear session and put user back into main page
  if (logout != null) {
    AuthProxy.clearSession();
    window.location.replace(window.location.toString().replace(window.location.search, ""));
  }

  // look if login page needs to be surpressed 
  //const external=new URLSearchParams(window.location.search).get("prompt");

  const params = new URLSearchParams(window.location.search);
  const external = params.get("prompt");
  
  sessionStorage.setItem("origin", window.location.origin);
  document.cookie = "kcdtoken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
  const allowedPrompts = ['false'];
  const govAllowedPrompts = ['gov'];
   var skipLogin = false;
   var govSkipLogin = false;
   if (external !== null && allowedPrompts.includes(external)) {
      skipLogin = true;
   }
     
   if (external !== null && govAllowedPrompts.includes(external)){
    govSkipLogin = true;
   }
   //if (external){
 
    // user has come from another application and is already signed in with OHID
    // supress the first sign on screen and kick off OHID call with PKCE
  if (skipLogin || govSkipLogin){
    if (
      (typeof sessionStorage.getItem("sessionId") == "undefined" ||
        sessionStorage.getItem("sessionId") == null) &&
      (code === null || code === "undefined")
    ) 
    if (govSkipLogin){
      sessionStorage.setItem("authType", "govId");
      AuthProxy.govIdRedirect(false); 
    }
    else
    {
        sessionStorage.setItem("authType", "ohid");
        AuthProxy.loginRedirect(false);   
    }
  }

 
  console.log("external: " + external);
  console.log("prompt: " + prompt);
  console.log("Query: " + query);
  console.log("AUTH TYPE: " + authType);
  console.log("CODE TYPE: " + code);
  console.log("SESSION ID: " + sessionStorage.getItem("sessionId"));
  console.log("CODE TYPE: " + code);

  console.log("AUTH TYPE: " + authType);
  console.log("CODE TYPE: " + code);
  console.log(process.env.REACT_APP_API_ENV)
  
  // no session id but a code in URL (already logged into ohid)
  var verifier = sessionStorage.getItem("verifier");
  var msidVerifier = sessionStorage.getItem("msidVerifier");
  var govIdVerifier = sessionStorage.getItem("govIdVerifier");
  var clientID;
  //console.log("AUTH TYPE: " + authType);
  if(authType === "ohid"){
    if (verifier && code) {
      // code from OHID login is found, so send code and verifier to OHID API call  
      sessionStorage.removeItem("logout");
      verifier = sessionStorage.getItem("verifier");
      clientID = configMap.rxClaimOauthClientId;
      var princeID = configMap.princeId;
      AuthProxy.session(verifier, code, clientID, princeID);
    }
    else if (resume) {
      var decoded=decodeURIComponent(resume);
      var sessionId=decoded.split('/')[2];
      var pass = configMap.pass;
      AuthProxy.postPingFed(sessionId,pass);
    }
    else if(!sessionStorage.getItem("sessionId") && !code) {
      // display home login screen
      sessionStorage.setItem("splunkAuth", configMap.splunkClientId);

      return ReactDOM.render(
        <React.StrictMode>
          <Login />
        </React.StrictMode>,
        document.getElementById("root")
      );
   }
  } else if(authType === "msid"){
    if (msidVerifier && code) {
      // code from msid login is found, so send code and verifier to azure API call
      sessionStorage.removeItem("logout");
      msidVerifier = sessionStorage.getItem("msidVerifier");
      clientID = configMap.azureClientId;
      AuthProxy.msidToken(msidVerifier, code, clientID);
    }
    else if (resume) {
      decoded=decodeURIComponent(resume);
      sessionId=decoded.split('/')[2];
      pass = configMap.pass;
      AuthProxy.msidPostPingFed(sessionId,pass);
    }
    else if(!sessionStorage.getItem("sessionId") && !code) {
      // display home login screen
      sessionStorage.setItem("splunkAuth", configMap.splunkClientId);

      return ReactDOM.render(
        <React.StrictMode>
          <Login />
        </React.StrictMode>,
        document.getElementById("root")
      );
   }
    
  } else if(authType === "govId"){
    if (govIdVerifier && code) {
      // code from GovId login is found, so send code and verifier to GovId API call  
      sessionStorage.removeItem("logout");
      govIdVerifier = sessionStorage.getItem("govIdVerifier");
      clientID = configMap.rxClaimOauthClientId;
      var princeID = configMap.princeId;
      AuthProxy.govIdSession(govIdVerifier, code, clientID, princeID);
    }
    else if (resume) {
      var decoded=decodeURIComponent(resume);
      var sessionId=decoded.split('/')[2];
      var pass = configMap.pass;
      AuthProxy.govIdPostPingFed(sessionId,pass);
    }
    else if(!sessionStorage.getItem("sessionId") && !code) {
      // display home login screen
      sessionStorage.setItem("splunkAuth", configMap.splunkClientId);

      return ReactDOM.render(
        <React.StrictMode>
          <Login />
        </React.StrictMode>,
        document.getElementById("root")
      );
   }
  }

  else if(!sessionStorage.getItem("sessionId") && !code) {
    // display home login screen
      sessionStorage.setItem("splunkAuth", configMap.splunkClientId);

    return ReactDOM.render(
      <React.StrictMode>
        <Login />
      </React.StrictMode>,
      document.getElementById("root")
    );
 }

});
